import styled, { css } from 'styled-components';
import { v2Color } from '@theme/v2';

// Shared card shell for the backlog card states (was the module-level `cardBase`
// style object). Applied to a div (clear / pending) and a button (unverified).
const cardBaseStyles = css`
  display: flex;
  align-items: center;
  gap: 14px;
  width: 100%;
  padding: 14px 16px;
  background: #fff;
  border: 1px solid #EDEFF2;
  border-radius: 6px;
  box-shadow: rgba(16,24,40,0.04) 0px 1px 2px;
  text-align: start;
`;

// Clear state shell: cardBase with gap overridden to 12.
export const ClearCard = styled.div`
  ${cardBaseStyles}
  gap: 12px;
`;

// Unverified state shell: cardBase as a real button (was a raw <button>).
export const UnverifiedCard = styled.button`
  ${cardBaseStyles}
  cursor: pointer;
  font-family: inherit;
`;

// Pending state shell: cardBase as a clickable div.
export const PendingCard = styled.div`
  ${cardBaseStyles}
  cursor: pointer;
`;

// Count column (was the module-level `countBlock` style object).
export const CountBlock = styled.span`
  display: grid;
  justify-items: center;
  gap: 1px;
  flex: 0 0 auto;
  min-width: 56px;
  padding-inline-end: 14px;
  border-inline-end: 1px solid #F1F3F7;
`;

// "ACTIVE" caption (was the module-level `activeLabel` style object).
export const ActiveLabel = styled.span`
  color: rgb(150,150,150);
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
`;

// Clear state: circular tick badge.
export const TickCircle = styled.span`
  display: inline-grid;
  place-content: center;
  flex: 0 0 auto;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: ${v2Color('#E1F2F0')};
  color: ${v2Color('#006169', 'text')};
`;

// Clear state: text column (no flex grow).
export const ClearContent = styled.span`
  display: grid;
  gap: 2px;
  min-width: 0;
`;

// Text column for the unverified / pending states.
export const Content = styled.span`
  display: grid;
  gap: 2px;
  min-width: 0;
  flex: 1 1 auto;
`;

// Primary title line, shared across all states.
export const Title = styled.span`
  color: ${v2Color('#272B41', 'text')};
  font-size: 14px;
  font-weight: 700;
`;

// Clear state subtitle (no line-height override).
export const ClearSubtitle = styled.span`
  color: rgb(112,112,112);
  font-size: 12.5px;
`;

// Subtitle for the unverified / pending states.
export const Subtitle = styled.span`
  color: rgb(112,112,112);
  font-size: 12.5px;
  line-height: 1.4;
`;

// Unverified state: blurred placeholder count.
export const BlurredCount = styled.span`
  color: ${v2Color('#006169', 'text')};
  font-size: 16px;
  font-weight: 700;
  line-height: 1.1;
  filter: blur(5px);
  user-select: none;
`;

// Pending state: active count value.
export const Count = styled.span`
  color: ${v2Color('#006169', 'text')};
  font-size: 16px;
  font-weight: 700;
  line-height: 1.1;
`;

// Unverified state: lock icon + title row.
export const LockRow = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 7px;
`;

// Trailing CTA link (Verify / View all), shared across the two interactive states.
export const ActionLink = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  flex: 0 0 auto;
  color: ${v2Color('#006169', 'text')};
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
`;
